import { Component } from '@angular/core';
import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss']

})
export class LoaderComponent { }
